import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
//
import { initUserInfo, setUserInfo } from '../redux/userInfo';
import { isImpersonating, finishImpersonation } from '../utils/impersonation';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  background: #3a3a3a;
  color: #fff;
  font-size: 0.85rem;
  padding: 6px 10px;
`;

const FinishButton = styled.button`
  background: #c0392b;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 4px 12px;
  font-size: 0.8rem;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

// 영업사원이 고객 세션으로 전환된 동안 상단에 표시되는 배너
export default function ImpersonationBanner() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);

  if (!isImpersonating()) return null;

  const customerName =
    [userInfo.firstname, userInfo.lastname].filter(Boolean).join(' ') ||
    userInfo.companyNm;

  const onFinish = () => {
    const repUserInfo = finishImpersonation();
    if (repUserInfo) {
      dispatch(initUserInfo());
      dispatch(setUserInfo(repUserInfo));
    }
    navigate('/rep-carts');
  };

  return (
    <Bar>
      <span>
        Impersonated as <b>{customerName}</b>
      </span>
      <FinishButton onClick={onFinish}>
        finish impersonated session
      </FinishButton>
    </Bar>
  );
}
